import { LuBookOpen, LuBrain, LuGraduationCap, LuHeart, LuLifeBuoy, LuShieldCheck } from "react-icons/lu";
import { GAME_IDS, SUBJECTS } from "../../shared/constants";
import { GameArt } from "./GameArt";
import { GAME_GROUPS } from "./GameTile";
import { GAME_META } from "./ui";

/** the site's slogan – one place, so that the title, the footer and the landing page always say the same */
export const SLOGAN = "Sjov læring for alle aldre!";

/** what each game trains – shown on the front page so that everybody can see how much thought is in every one of them */
export const GAME_LEARN: Record<string, string> = {
  monopoly: "Regning og alle fag",
  kortkamp: "Hurtig tænkning",
  slagskibe: "Koordinater og taktik",
  speedrun: "Tempo og viden",
  fire: "Logik",
  skak: "Strategi",
  kryds: "Logik",
  quizduel: "Viden i alle fag",
  taarn: "Viden og strategi",
  videnraes: "Hurtig viden",
  skattejagt: "Viden og mod",
  ludo: "Viden og held",
  yatzy: "Regning",
  sudoku: "Tal og logik",
  videnspar: "Hukommelse",
  verden: "Opdagelse og viden",
};

/** the small row of promises under the heading */
function CareStrip() {
  const items = [
    { icon: LuBookOpen, title: `${SUBJECTS.length} fag`, text: "Dansk, matematik, engelsk og mere" },
    { icon: LuGraduationCap, title: "0.–9. klasse", text: "Passer til dit klassetrin" },
    { icon: LuLifeBuoy, title: "Hjælp, ikke straf", text: "Går du i stå, får du hjælp" },
    { icon: LuShieldCheck, title: "Tryg og privat", text: "Ingen chat og ingen betaling" },
  ];
  return (
    <ul className="sc-care">
      {items.map((it, i) => (
        <li key={it.title} data-reveal style={{ ["--i" as any]: i }}>
          <span className="sc-care-ico" aria-hidden="true"><it.icon size={26} /></span>
          <span><b>{it.title}</b><small>{it.text}</small></span>
        </li>
      ))}
    </ul>
  );
}

/**
 * v21: "Vores spil" – every game with its own picture, what it is about and what it trains. For the front page, where the visitor is not logged in
 * yet (the cards therefore are not links; the sign-up button below them is).
 */
export function GameShowcase() {
  return (
    <section className="showcase" aria-labelledby="sc-h">
      <div className="sc-head" data-reveal>
        <span className="sc-eyebrow"><LuHeart aria-hidden="true" size={16} /> Lavet med omtanke</span>
        <h2 id="sc-h" className="sc-title">{GAME_IDS.length} sjove spil</h2>
        <p>Et rigtigt svar er din nøgle – så lærer du, mens du leger!</p>
      </div>
      <CareStrip />
      {GAME_GROUPS.map((g) => (
        <div key={g.id} className="sc-group">
          <h3 data-reveal>{g.title} <small>{g.sub}</small></h3>
          <div className="sc-grid">
            {g.games.map((id, i) => {
              const m = GAME_META[id];
              if (!m) return null;
              return (
                <article key={id} className="sc-card" data-reveal style={{ ["--i" as any]: i % 4, ["--c1" as any]: m.c1, ["--c2" as any]: m.c2 }} data-tilt="5">
                  <span className="sc-art" aria-hidden="true"><GameArt game={id} className="sc-pic" /></span>
                  <div className="sc-body">
                    <strong>{m.name}</strong>
                    <p>{m.tagline}</p>
                    <p className="sc-learn"><LuBrain aria-hidden="true" size={15} /> <span>{GAME_LEARN[id]}</span></p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}

/** the line at the bottom of every page */
export function SiteFooter() {
  return (
    <footer className="sitefoot">
      <b>EduBattle</b> <span aria-hidden="true">–</span> <span>{SLOGAN}</span>
    </footer>
  );
}
